<div class="dqf-item-container" fxLayout>
  <div >
    <ngx-skeleton-loader
      appearance="circle"
      [theme]="{
        height: '61px',
        width: '61px'
      }"
    ></ngx-skeleton-loader>
  </div>
  <div  class="company-description-loading">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        width: '70%'
      }"
    ></ngx-skeleton-loader>
  </div>
  <div  class="status-container">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        width: '50%'
      }"
    ></ngx-skeleton-loader>
  </div>
</div>
